export const timerDuration = 15
export const initialTimerDuration = 5 // FIXME when backend's ready